/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getPackageDeliveryTypesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_PACKAGE_DELIVERY_TYPES_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getPackageDeliveryTypeById: (id) => {
    return axios.get(API_ENDPOINTS.GET_PACKAGE_DELIVERY_TYPE_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addPackageDeliveryType: (data) => {
    return axios.post(API_ENDPOINTS.ADD_PACKAGE_DELIVERY_TYPE, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  updatePackageDeliveryType: (id, data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PACKAGE_DELIVERY_TYPE_BY_ID + "/" + id, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deletePackageDeliveryType: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_PACKAGE_DELIVERY_TYPE_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
